"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// @ts-strict-ignore
// Modified from https://github.com/palmerhq/radio-group
var react_1 = require("react");
var shared_1 = require("./shared");
var keyCodes = {
    RETURN: 13,
    SPACE: 32,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
var Radio = (0, react_1.forwardRef)(function (_a, maybeOuterRef) {
    var children = _a.children, onBlur = _a.onBlur, onFocus = _a.onFocus, value = _a.value, props = __rest(_a, ["children", "onBlur", "onFocus", "value"]);
    var ref = (0, react_1.useRef)(null);
    var ctx = (0, react_1.useContext)(shared_1.RadioGroupContext);
    var groupId = ctx.groupId, otherRadioValues = ctx.otherRadioValues, setChecked = ctx.setChecked, contextValue = ctx.value;
    var index = otherRadioValues.findIndex(function (i) { return i === value; });
    var count = otherRadioValues.length - 1;
    (0, react_1.useEffect)(function () {
        if (contextValue === value) {
            // Don't hijack focus unless the currently focused element is part of the same radio group
            var activeElement = document === null || document === void 0 ? void 0 : document.activeElement;
            if (!activeElement.dataset || activeElement.dataset.radioGroupId !== groupId) {
                return;
            }
            if (maybeOuterRef && maybeOuterRef.current !== null) {
                maybeOuterRef.current.focus();
            }
            else if (ref.current !== null) {
                ref.current.focus();
            }
        }
    }, [contextValue, value, maybeOuterRef, groupId]);
    var handleKeyDown = (0, react_1.useCallback)(function (event) {
        event.persist();
        var flag = false;
        function setPrevious() {
            if (index === 0) {
                setChecked(otherRadioValues[count]);
            }
            else {
                setChecked(otherRadioValues[index - 1]);
            }
        }
        function setNext() {
            if (index === count) {
                setChecked(otherRadioValues[0]);
            }
            else {
                setChecked(otherRadioValues[index + 1]);
            }
        }
        switch (event.keyCode) {
            case keyCodes.SPACE:
            case keyCodes.RETURN:
                setChecked(value);
                flag = true;
                break;
            case keyCodes.UP:
            case keyCodes.LEFT:
                setPrevious();
                flag = true;
                break;
            case keyCodes.DOWN:
            case keyCodes.RIGHT:
                setNext();
                flag = true;
                break;
            default:
                break;
        }
        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }, [index, setChecked, otherRadioValues, count, value]);
    var handleClick = (0, react_1.useCallback)(function () {
        setChecked(value);
    }, [value, setChecked]);
    var handleBlur = (0, react_1.useCallback)(function (e) {
        if (onBlur) {
            onBlur(e);
        }
    }, [onBlur]);
    var handleFocus = (0, react_1.useCallback)(function (e) {
        if (onFocus) {
            onFocus(e);
        }
    }, [onFocus]);
    // Sets tabIndex="0" on the first sibling when none are selected
    var tabIndex = contextValue === value ? 0 : -1;
    var isFirstSiblingAndNotSelected = !contextValue && value === otherRadioValues[0];
    var finalTabIndex = isFirstSiblingAndNotSelected ? 0 : tabIndex;
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, props, { role: "radio", tabIndex: finalTabIndex, "aria-checked": contextValue === value, onBlur: handleBlur, onFocus: handleFocus, onClick: handleClick, onKeyDown: handleKeyDown, "data-radio-group-id": groupId, ref: function (el) {
            if (maybeOuterRef) {
                maybeOuterRef.current = el;
            }
            ref.current = el;
        } }, { children: children })));
});
exports.default = Radio;
